// useNextCronCountdown.ts
import { useEffect, useState } from "react";

function getTimeToNextRun() {
  const now = new Date();
  const next = new Date(now);

  const minutes = now.getMinutes();

  if (minutes < 30) {
    // Next :30
    next.setMinutes(30, 0, 0);
  } else {
    // Next :00 of the next hour
    next.setHours(now.getHours() + 1, 0, 0, 0);
  }

  const diffMs = next.getTime() - now.getTime();
  const totalSeconds = Math.max(0, Math.floor(diffMs / 1000));
  const mm = Math.floor(totalSeconds / 60);
  const ss = totalSeconds % 60;

  return `${mm}m ${ss.toString().padStart(2, "0")}s`;
}

export function useNextCronCountdown() {
  const [label, setLabel] = useState(getTimeToNextRun);

  useEffect(() => {
    const id = setInterval(() => {
      setLabel(getTimeToNextRun());
    }, 1000);

    return () => clearInterval(id);
  }, []);

  return label;
}
